import { useTranslate } from '@va/localization';
import { useMemo } from 'react';
import { IgnoreOwnVisitsCardWix } from './ignore-own-visits-card';
import { ResetDataCardWix } from './reset-data-card';
import { TrackingCodeCardWix } from './tracking-code-card';
import { UpgradePlanCardWix } from './upgrade-plan-card';

export const useCommonGeneralSettingsCardsWix = () => {
  const translate = useTranslate();

  const cards = useMemo(
    () => ({
      trackingCodeCard: {
        id: 'tracking-code',
        title: translate('settings.navigation.trackingCode.title'),
        component: <TrackingCodeCardWix />,
        subTitle: 'wix',
      },
      upgradePlan: {
        id: 'upgrade-plan',
        title: translate('settings.navigation.upgradePlan.title'),
        component: <UpgradePlanCardWix />,
        subTitle: 'wix',
      },
      ignoreOwnVisits: {
        id: 'ignore-own-visits',
        title: translate('settings.navigation.ignoreSelfTracking.title'),
        component: <IgnoreOwnVisitsCardWix />,
      },
      resetData: {
        id: 'reset-data',
        title: translate('settings.navigation.resetData.title'),
        component: <ResetDataCardWix />,
      },
    }),
    [translate],
  );

  return cards;
};
